import { Component, Input } from "@angular/core";
import { ModalController } from "@ionic/angular";

export type DiagnosticsConsentModalVariant = "prompt" | "settings";

@Component({
  selector: "app-diagnostics-consent-modal",
  templateUrl: "./diagnostics-consent-modal.component.html",
  styleUrls: ["./diagnostics-consent-modal.component.scss"],
  standalone: false,
})
export class DiagnosticsConsentModalComponent {
  @Input() variant: DiagnosticsConsentModalVariant = "prompt";
  @Input() supportReason?: string;

  constructor(private modalCtrl: ModalController) {}

  decline(): void {
    void this.modalCtrl.dismiss("dismiss", "cancel");
  }

  accept(): void {
    void this.modalCtrl.dismiss("accept", "confirm");
  }
}
